(function() {
    // Get the elements
    const btn = document.getElementById('navbar-button');
    const navbar = document.getElementById('navbar');
    const content = document.getElementById('navbar-content');
    // Function to toggle the menu visibility
    btn.addEventListener('click', ()=>{
        navbar.classList.toggle('active'); // Add or remove the 'active' class
        content.classList.toggle('active');
    });
    // Close the menu if a link is clicked
    const menuLinks = document.querySelectorAll('#navbar-content a');
    menuLinks.forEach((link)=>{
        link.addEventListener('click', ()=>{
            navbar.classList.remove('active'); // Close the menu when a link is clicked
            content.classList.remove('active'); // Close the menu when a link is clicked
        });
    });
})();

//# sourceMappingURL=booking.931fad1e.js.map
